import { useState, useEffect, useRef } from 'react';
import { fetchOperationCatalog } from './catalogClient';
import { catalogFixture } from './catalogFixture';
import type { OperationTypeDefinition } from '@/graph/domain/types';

interface CatalogResult {
  data: OperationTypeDefinition[];
  isLoading: boolean;
  error: Error | null;
}

/**
 * Hook that fetches the operation catalog from the backend.
 * Falls back to the fixture if the API call fails.
 * Caches the result for the lifetime of the component.
 */
export function useOperationCatalog(): CatalogResult {
  const [data, setData] = useState<OperationTypeDefinition[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    fetchOperationCatalog()
      .then((result) => {
        setData(result.length > 0 ? result : catalogFixture);
        setIsLoading(false);
      })
      .catch((err) => {
        console.warn('Catalog fetch failed; using fixture.', err);
        setError(err instanceof Error ? err : new Error(String(err)));
        setData(catalogFixture);
        setIsLoading(false);
      });
  }, []);

  return { data, isLoading, error };
}
